export default "__VITE_ASSET__BIdBQux___"